import React from 'react'

const pipeline = [
  'Market Data',
  'Research Pipeline',
  'Signal Engine',
  'Execution Engine',
  'Risk Engine',
  'Portfolio Allocation'
]

const Reels = () => {
  return (
    <div id='reels' className='py-28  lg:py-32 xl:py-44 px-5 md:px-16 lg:px-20 flex flex-col justify-center items-center bg-[#111111]'>
      <div className='w-full max-w-screen-min-screen'>
        <h1 className='text-primary-dark metro-semi uppercase mb-5' data-aos="fade-up" data-aos-duration="1000">/ Research Architecture</h1>
        <h1 data-aos="fade-up" data-aos-duration="1000" className='text-white section-headline domin mb-10 lg:mb-12'>Qlab operates a modular research stack designed to study, validate, and deploy systematic models across global markets.</h1>

        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-4 mb-12'>
          {pipeline.map((step) => (
            <div key={step} className='bg-black bg-opacity-30 border border-secondary-light text-white metro p-4 text-center'>
              {step}
            </div>
          ))}
        </div>
        <div className='bg-black bg-opacity-30 border border-secondary-light p-8 text-secondary-light metro text-[18px]'>
          Due to the proprietary nature of our research workflows, internal data pipelines, model diagnostics, and execution telemetry are not publicly displayed.
        </div>
      </div>
    </div>
  )
}

export default Reels
